import SetupHikDlysjgSmsModal from './setup-hik-dlysjg-sms-modal.vue'
export default SetupHikDlysjgSmsModal
